import restApi from "@plannel/services/utils/rest-api";

const get = params => {
  return restApi.post("/api/bf-feature-sales", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/bf-feature-sales/csv", params);
};

const upsert = data => {
  return restApi.post("/api/bf-feature-sales/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/bf-feature-sales/${ids}`);
};

const bfFeatureSalesService = {
  get,
  getAllForCSV,
  upsert,
  remove
};

export default bfFeatureSalesService;
